import React, { useContext, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { HomePageContext } from 'providers/HomePageProvider';

import styles from 'components/molecules/HomePageSlideLeftItem/HomePageSlideLeftItem.module.scss';
export const HomePageSlideLeftItem = ({ diets, currentSlideLeftItem }) => {
  const context = useContext(HomePageContext);
  const ref = useRef(null);

  useEffect(() => {
    if (context.animationStart === false) return;
    if (context.animationActive) {
      ref.current.classList.add(styles.prevAnimation);
    } else {
      ref.current.classList.add(styles.nextAnimation);
    }
  }, [context]);

  return (
    <section className={styles.wrapperleft}>
      {diets.map((diet, index) => {
        return (
          index === currentSlideLeftItem && (
            <img
              ref={ref}
              className={styles.img}
              src={diet.image}
              key={index}
              alt="dietphoto"
            ></img>
          )
        );
      })}
    </section>
  );
};

HomePageContext.propTypes = {
  diets: PropTypes.array,
  currentSlideLeftItem: PropTypes.number,
};
